import { BaseApi } from './BaseApi';
export class DomainApi extends BaseApi {
    constructor(config) {
        super(config);
    }
    getDomain(id) {
        return this.providers.makeRequest({
            route: this.buildRoute('domain'),
            params: {
                id,
            },
        });
    }
    getAllDomains() {
        return this.providers.makeRequest({
            route: this.buildRoute('domains'),
        });
    }
    deleteDomain(id) {
        return this.providers.makeRequest({
            route: this.buildRoute('domain'),
            method: 'DELETE',
            params: {
                id,
            },
        });
    }
    deleteAllDomains() {
        return this.providers.makeRequest({
            route: this.buildRoute('domains'),
            method: 'DELETE',
        });
    }
    updateDomain(id, data) {
        return this.providers.makeRequest({
            route: this.buildRoute('domain'),
            method: 'PATCH',
            data,
            params: {
                id,
            },
        });
    }
    createDomain(data) {
        return this.providers.makeRequest({
            route: this.buildRoute('domain'),
            method: 'POST',
            data,
        });
    }
}
//# sourceMappingURL=domainApi.js.map